export const validClassTypes = [
  { value: 'FT', label: 'Fulltime' },
  { value: 'PT', label: 'Parttime' },
  { value: 'SA', label: 'Scholl Age' },
  { value: 'VPK', label: 'VPK Only' },
];
